import { render } from "./RuiCheckbox.vue?vue&type=template&id=ab7dfa0c&scoped=true"
import script from "./RuiCheckbox.vue?vue&type=script&lang=ts"
export * from "./RuiCheckbox.vue?vue&type=script&lang=ts"

import "./RuiCheckbox.vue?vue&type=style&index=0&id=ab7dfa0c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ab7dfa0c"

export default script